<template>
  <v-flex xs4>
    <v-card elevation="0">
      <div>
        <ve-histogram :data="chartData" :settings="chartSettings"></ve-histogram>
      </div>
      <div class="text-xs-center">Updated: {{ chartData.rows[0].updated }}</div>
    </v-card>
  </v-flex>
</template>

<script>
import VeHistogram from 'v-charts/lib/histogram.common'

export default {
    data() {
        this.chartSettings = {
          min: [0],
          max: [2400],
          label: {
            show: true, position: "top"
            },
          labelMap: {
            temperature: 'Kiln (F)',
            junctionTemp: 'Exterior (F)'
            },
          metrics: ['temperature', 'junctionTemp'],
          dimension: ['id']
        }
        return {}
    },
    components: {
        VeHistogram
    },
    props: {
        chartData: {
            type: Object
        }
    }
  }
</script>

<style scoped>
</style>